// styles
import '@/scss/pages/builder-template.scss'
// hooks
import { useQuizDisciplineGrade } from '@/js/common/quiz-discipline-grade'
import { useSidebarBottom } from '@/js/common/sidebar-bottom'
import { useSlider } from '@/js/common/slider'
import header from '@/js/layout/header'
import { useImageHeroVideo } from '@/js/section/about-us/image-hero-video'
import { useVideoBlock } from '@/js/section/common/video-block'
import moveToLand from '@/js/section/home/move-to-land'
import useFAQ from '@/js/section/pricing/faq'
import { useScroller } from '@/js/section/home/scroller'

document.addEventListener('DOMContentLoaded', (): void => {
  header()
  useFAQ()
  useSlider()
  moveToLand()
  useImageHeroVideo()
  useVideoBlock()
  useSidebarBottom()
  useQuizDisciplineGrade()
  useScroller({
    scrollerItems: '.scroller-items',
    innerSelector: '.scroller-items__inner',
    itemAttributes: 'aria-hidden'
  })
})
